/**
 * Scroll reveal animations (GSAP + ScrollTrigger).
 *
 * @package HelloElementorChild
 */

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { prefersReducedMotion } from './camst-counter.js';

gsap.registerPlugin(ScrollTrigger);

var revealInstances = new WeakMap();

export function initCamstReveal(scope) {
  var roots = [];

  if (!scope) {
    roots = Array.prototype.slice.call(document.querySelectorAll('[data-camst-reveal-root]'));
  } else if (scope.matches && scope.matches('[data-camst-reveal-root]')) {
    roots = [scope];
  } else {
    roots = Array.prototype.slice.call(scope.querySelectorAll('[data-camst-reveal-root]'));
  }

  roots.forEach(function (root) {
    if (root.dataset.camstRevealInit === '1') {
      return;
    }

    root.dataset.camstRevealInit = '1';

    var items = Array.prototype.slice.call(root.querySelectorAll('.camst-reveal'));

    if (root.classList.contains('camst-reveal')) {
      items.unshift(root);
    }

    if (!items.length) {
      return;
    }

    if (prefersReducedMotion()) {
      items.forEach(function (item) {
        item.style.opacity = '1';
        item.style.transform = 'none';
      });
      return;
    }

    var ctx = gsap.context(function () {
      items.forEach(function (item) {
        var slideOnly = item.classList.contains('camst-reveal--slide');
        var fromVars = slideOnly ? { y: 50 } : { y: 50, opacity: 0 };
        var toVars = {
          y: 0,
          duration: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: item,
            start: 'top 90%',
            toggleActions: 'play none none none',
          },
        };

        if (!slideOnly) {
          toVars.opacity = 1;
        }

        gsap.fromTo(item, fromVars, toVars);
      });
    }, root);

    revealInstances.set(root, ctx);
  });
}

export function teardownCamstReveal(scope) {
  if (!scope) {
    return;
  }

  var roots = scope.matches && scope.matches('[data-camst-reveal-root]')
    ? [scope]
    : Array.prototype.slice.call(scope.querySelectorAll('[data-camst-reveal-root]'));

  roots.forEach(function (root) {
    var ctx = revealInstances.get(root);

    if (ctx) {
      ctx.revert();
      revealInstances.delete(root);
    }

    delete root.dataset.camstRevealInit;
  });
}

export function refreshCamstReveal() {
  ScrollTrigger.refresh();
}
